

<div class="container-loader" *ngIf="isBusy">
  <ngx-loading [show]="isBusy" [config]="loaderConfig"></ngx-loading>
</div>
<div class="modal-header">
  <h6 class="modal-title"><span *ngIf="popupTitle" [innerHTML]="popupTitle | safe_html"></span><span *ngIf="title" [innerHTML]="title | safe_html"></span><span *ngIf="!title">{{ popTitle }}</span></h6>
  <div class="actions-container" *ngIf="actions.length > 0">
    <span *ngFor="let action of actions">
      <input type="button" *ngIf="!action.DisplayOnGroup" value="{{ action.ActionDisplay }}" class="btn btn-primary mr-2 btn-action others" (click)="setCurrentAction(action)">
    </span>
  </div>
  <button type="button" class="close close-modal" data-dismiss="modal" aria-label="Close" (click)="hide()">
    <span aria-hidden="true" style="font-size: 25px;">&times;</span>
  </button>
</div>
<div #modalBody class="modal-body custom-scrollbar">
  <ng-container *ngIf="type">
    <ng-container [ngSwitch]="type.toUpperCase()">
      <div *ngSwitchCase="'COMPARE'">
        <app-comparison [setComponentId]="componentId" (compareActions)="setActions($event)" [triggerAction]="currentAction" (loadingPopup)="handleLoading($event)" (hidePopup)="hide()"></app-comparison>
      </div>
      <ng-container *ngSwitchCase="'SUMMARY'">
        <app-sub-summary #subsummary [componentIdSet]="componentId" (hidePopup)="hide()" 
        (setPopupTitle)="title = $event" [isSummaryPopup]="true" (popupSelectedId)="onSelected($event)"
        [setExpandSummary]="expandSummary"></app-sub-summary>
      </ng-container>
      <ng-container *ngSwitchCase="'FORM'">
        <app-detail-form [setComponentId]="componentId" (detailActions)="setActions($event)" [actionOnDetail]="currentAction" [isPopup]="true"></app-detail-form>
      </ng-container>
      <ng-container *ngSwitchCase="'OTHERS'">
        <object width="100%" height="100%" [data]="source | safe"></object>
        <div style="height: 36px;width: 240px;position: absolute;bottom: 16px;right: 16px;background-color: #eaeaea;"></div>
      </ng-container>
      <ng-container *ngSwitchCase="'CHART'">
        <app-chart [setComponentId]="componentId" [isExpandChart]="true"></app-chart>
      </ng-container>
      <ng-container *ngSwitchCase="'NOTIFICATION'">
        <div [innerHTML]="message | safe_html"></div>
      </ng-container>
    </ng-container>
  </ng-container>
</div>